export const PUBLIC_ROUTES = [
    'login',
    'trial-signup',
    'trial-success',
    'forgot-password',
    'reset-password',
    'password-setup',
    'password-change',
    'verify-email',
    'verify-email-change',
    'link-account',
    // METALARK-835: cross-customer invitation acceptance. The email
    // link lands here before the user has signed in; the page itself
    // handles the auth gate (preview is anonymous; accept/decline
    // require sign-in via the page's own returnto-aware login link).
    'accept-invitation',
    'not-found'
] as const;

export type PublicRoute = typeof PUBLIC_ROUTES[number];

export const PUBLIC_BUNDLE_PATH = '/assets/public';
export const BUNDLE_NAME = 'public';
export const REQUIRED_ROLE = null; // No authentication required
